export enum BanUserImageEnum {
  CHARACTER = 'CHARACTER',
  BOOK_COVER = 'BOOK_COVER',
  MANGA_COVER = 'MANGA_COVER',
  NOVEL_COVER = 'NOVEL_COVER',
  PROFILE_IMAGE = 'PROFILE_IMAGE',
  PROFILE_COVER = 'PROFILE_COVER',
}
